import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { MassReassignBookingsDialogComponent } from './mass-reassign-bookings-dialog-component';

export interface IMassReassignBookingsDialogProps {
  bookingIds: string[];
  onClose?: () => void;
}

export function MassReassignBookingsDialog({ bookingIds, onClose }: IMassReassignBookingsDialogProps) {
  const [newCaseworkerId, setNewCaseworkerId] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  function handleClose() {
    setIsOpen(false);
    onClose?.();
  }

  async function handleConfirm() {
    if (!newCaseworkerId) {
      return;
    }

    try {
      setIsLoading(true);
      const client = moduleClientFactory.createCitizenInterviewClient(true);
      await client.massReassignBookings({
        bookingIds,
        newCaseworkerId,
      });
      enqueueSnackbar(
        `Massetildeling igangsat for ${bookingIds.length} samtaler. Du vil få advis ved evt. fejl.`,
        { variant: 'success' }
      );
      handleClose();
    } catch {
      enqueueSnackbar('Massetildelingen kunne ikke igangsættes.', { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  }

  if (!isOpen) {
    return null;
  }

  return (
    <MassReassignBookingsDialogComponent
      bookingCount={bookingIds.length}
      newCaseworkerId={newCaseworkerId}
      isLoading={isLoading}
      isOpen={isOpen}
      onCaseworkerChange={setNewCaseworkerId}
      onConfirm={handleConfirm}
      onClose={handleClose}
    />
  );
}
